export const standardFilterFields = [
	'projectId',
	//
	'organizationId',
	'customerId',
] as const;

export const filterFields = [...standardFilterFields] as const;
